import { Text } from '@/components/Text';

import ResponsiveText from '@/components/SharedComponents/ResponsiveText/ResponsiveText';
import { styles } from './styles';

export function WordSquare({ word, correctWords }) {
  const wordsSplit = word.split(' ');
  return (
    <ResponsiveText>
      {wordsSplit.map((eachItem, i) => {
        const isShown = correctWords[i] === eachItem;
        return (
          <Text
            style={isShown ? styles.visibleWord : styles.hiddenWord}
            key={i}
            isResponsiveText={true}
          >
            {eachItem + ' '}
          </Text>
        );
      })}
    </ResponsiveText>
  );
}
